module.exports = __webpack_public_path__ + "img/cases-brand-vive-7.a021876e.jpg";